import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  toggled = false;
  _hasBackgroundImage = true;
  menus = [
        {
      title: 'Dashboard',
      active: false,
      type: 'simple',
      path: '/dashboard'
       },
    {
      title: 'Get Help',
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'Create new request/ Raise an issue',
          path: '/CreateSr'
        },
        {
          title: 'My History',
          path:'/ViewMyServiceRequest/1'
        },
      ]
    },
    {
      title: 'Service Requests',
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'Assigned to me',
          path: '/ViewSR/2'
        },
      ]
    },
    {
      title: 'My Group’s Service Request',
      type: 'dropdown',
      submenus: [
        {
          title: 'All requests',
          path: '/AllViewSR/3'
        },
        {
          title: 'Assigned',
          path: '/AssignedViewSR/4'
        },
        {
          title: 'In Progress',
          path: '/OpenViewSR/5'
        },
        {
          title: 'Awaiting Requestor',
          path: '/AwViewSR/6'
        },
        {
          title: 'Cancelled',
          path: '/CanViewSR/7'
        },
      ]
    },
    {
      title: 'My Group’s Service Request – Unassigned',
      active: false,
      path: '/MyGroupSR/8'
    },
    {
      title: 'My Group’s History',
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'All requests',
        },
        {
          title: 'Cancelled'
        },
        {
          title: 'Resolved'
        }
      ]
    },
    {
      title: 'Masters',
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'Category Master',
          path: '/categoryMaster'
        },
        {
          title: 'Sub Category',
          path: '/SubCategory'
        },
        {
          title: 'Item Master',
          path: '/itemMaster'
        },
        {
          title: 'Assigment Group',
          path: '/AssignmentGroup'
        },
        {
          title: 'Mapping Group And Item',
          path: '/MappingGroupItem'
        },
        {
          title: 'Manage Escalation Matrix',
          path: '/EscalationSequence'
        }
      ]
    },
    {
      title: 'Reports',
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'SLA report',
        },
        {
          title: 'Aging report'
        },
        {
          title: 'Status report'
        },
        {
          title: 'Detailed report – Full Dump'
        },
        {
            title: 'Final report'
        },
        {
          title: 'Admin BarChart',
          path: '/AdminBarChart'
        }
      ]
    },
  ];
  constructor() { }

  toggle() {
    this.toggled = ! this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuList() {
    return this.menus;
  }

  get hasBackgroundImage() {
    return this._hasBackgroundImage;
  }

  set hasBackgroundImage(hasBackgroundImage) {
    this._hasBackgroundImage = hasBackgroundImage;
  }
}
